<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-23 10:09:17
 * @LastEditTime: 2019-08-22 16:33:47
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="mapZoom">
    <div class="btn zoomIn" @click="changeLevel(1)">+</div>
    <div class="btn zoomOut" @click="changeLevel(0)">-</div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  methods: {
    changeLevel (type) {
      if (type === 1) {
        this.$emit('mapZoomChange', type);
      } else {
        this.$emit('mapZoomChange', type);
      }
    }
  }
};
</script>
<style lang="scss">
.mapZoom {
  position: relative;
  &::before{
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    width: 40px;
    height: 1px;
    background: rgba(255,255,255,0.2);
  }
  .btn {
    // width: 70px;
    // height: 70px;
    text-align: center;
    line-height: 70px;
    background: $color-opacity-primary;
    color: $color-white;
    font-size: 30px;
    &.zoomIn {
      border-top-left-radius: 35px;
      border-top-right-radius: 35px;
    }
    &.zoomOut {
      border-bottom-left-radius: 35px;
      border-bottom-right-radius: 35px;
    }
  }
}
@media (orientation: portrait) {
  .mapZoom {
  position: relative;
  &::before{
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    width: 40px;
    height: 1px;
    background: rgba(255,255,255,0.2);
  }
  .btn {
    text-align: center;
    line-height: 128px;
    background: $color-opacity-primary;
    color: $color-white;
    font-size: 80px;
    &.zoomIn {
      border-top-left-radius: 60px;
      border-top-right-radius: 60px;
    }
    &.zoomOut {
      border-bottom-left-radius: 60px;
      border-bottom-right-radius: 60px;
    }
  }
}
}
</style>

